import { TrendingUp } from 'lucide-react';
import { siteData } from '../../data/mock';
import { useInView } from '../../hooks/useInView';

export const GrowthSection = () => {
  const { growth } = siteData;
  const [ref, isInView] = useInView();

  return (
    <section className="py-[90px] lg:py-[110px] bg-[#f5f3ef]">
      <div
        ref={ref}
        className={`max-w-[1200px] mx-auto px-6 lg:px-8 ${
          isInView ? 'animate-fade-in-up' : 'opacity-0'
        }`}
      >
        <div className="max-w-[680px]">
          <div
            className="w-11 h-11 rounded-xl bg-[#2d6a5a]/10 flex items-center justify-center mb-6"
          >
            <TrendingUp size={20} className="text-[#2d6a5a]" />
          </div>

          <h2 className="font-heading text-[1.85rem] lg:text-[2.5rem] font-bold text-stone-900 leading-[1.15] tracking-[-0.01em]">
            {growth.headline}
          </h2>

          <p className="mt-5 text-[1.05rem] text-stone-500 leading-[1.7]">
            {growth.description}
          </p>

          <p className="mt-3 text-[0.95rem] text-stone-700 leading-[1.7] font-medium">
            {growth.detail}
          </p>
        </div>
      </div>
    </section>
  );
};
